import React from "react";
import { Spacer, Text } from "../dynamic.components";

export const OpcUa: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <Text text="The UNICORN™ software uses a standard for open platform communication (OPC), allowing for real‑time and historical data access as well as third‑party software control." />
        <Spacer />
        <Text text="A Profibus™ node is available for connection to external programmable logic controller (PLC)/distributed control system (DCS) such as DeltaV." />
      </div>
    </>
  );
};
